import { authorizationManagerService } from '@/services';
import Vue from 'vue';

Vue.prototype.$isAdmin = () => authorizationManagerService.isAdmin;
